module.exports = __webpack_public_path__ + "assets/img/img2.f2917dd2.png";